// extracted by mini-css-extract-plugin
export default {"popupContainer":"VideoPopup_popupContainer__MjBo1","backdrop":"VideoPopup_backdrop__5MuhL","popupContent":"VideoPopup_popupContent__7gzvH","closeIcon":"VideoPopup_closeIcon__Lorik"};